import { render, staticRenderFns } from "./Aluno.vue?vue&type=template&id=1919c028"
var script = {}
import style0 from "./Aluno.vue?vue&type=style&index=0&id=1919c028&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports